import { Component, computed, input, InputSignal, isDevMode, Signal } from '@angular/core';

import { LandingSection } from '@core/cms/landing.cms';

/**
 * Fallback for any section whose `__typename` has no registered component (including the CMS `Error`
 * member). Renders a small diagnostic placeholder in dev mode only, so production never shows it.
 */
@Component({
    selector: 'cms-unknown-section',
    templateUrl: './unknown-section.html',
    styleUrl: './unknown-section.scss',
})
export class CmsUnknownSection {
    public readonly section: InputSignal<LandingSection> = input.required<LandingSection>();

    protected readonly isDevMode: boolean = isDevMode();

    /** The CMS `Error` member carries a `message`; surface it for debugging when present. */
    protected readonly message: Signal<string | null> = computed((): string | null => {
        const data: LandingSection = this.section();

        return data.__typename === 'Error' ? (data.message ?? null) : null;
    });
}
